module.exports = __webpack_public_path__ + "88ac98491b09d132db3564c646361e22.png";